// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".webex-meeting-widget-demo{width:100%;height:600px}.webex-select-control{margin-top:8px;color:#121212}.webex-warning{color:#D1D3D4}.webex-error{color:#de3434}\n", ""]);
// Exports
module.exports = exports;
